import { render } from "./listWrapper.vue?vue&type=template&id=96b35746&scoped=true&ts=true"
import script from "./listWrapper.vue?vue&type=script&lang=ts"
export * from "./listWrapper.vue?vue&type=script&lang=ts"

import "./listWrapper.vue?vue&type=style&index=0&id=96b35746&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b35746"]])

export default __exports__